import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { IFormItemProps } from '../../types/components/form';
import { IRadiosLayout } from '../../types/layout/radios';

type Props = IRadiosLayout & IFormItemProps;

const Radios = ({
    data, disabled, value: valueFromProps, onChange,
}: Props) => {
    const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        if (typeof onChange === 'function') {
            onChange(e.target.value);
        }
    };

    return data.map(({ label, value }) => {
        const uuid = uuidv4();
        return (
            <div className="form-check">
                <input className="form-check-input" disabled={disabled} type="radio" id={uuid} onChange={onChangeHandler} checked={valueFromProps === value.toString()} value={value} />
                <label className="form-check-label" htmlFor={uuid}>
                    {label}
                </label>
            </div>
        );
    });
};

export default Radios;
